import React from 'react';
import CorporateHeader from '../components/CorporateHeader';
import CorporateHero from '../components/CorporateHero';
import ExecutiveProfile from '../components/ExecutiveProfile';
import CoreDomains from '../components/CoreDomains';
import CorporateCareerTimeline from '../components/CorporateCareerTimeline';
import IndustryNetwork from '../components/IndustryNetwork';
import LeadershipMandate from '../components/LeadershipMandate';
import PotentialRoles from '../components/PotentialRoles';
import ProfessionalGallery from '../components/ProfessionalGallery';
import CorporateContact from '../components/CorporateContact';
import CorporateFooter from '../components/CorporateFooter';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#0A192F] text-white font-body">
      <CorporateHeader />
      <CorporateHero />
      <ExecutiveProfile />
      <CoreDomains />
      <CorporateCareerTimeline />
      <IndustryNetwork />
      <LeadershipMandate />
      <PotentialRoles />
      <ProfessionalGallery />
      <CorporateContact />
      <CorporateFooter />
    </div>
  );
};

export default Home;